export const convertToDate = (date: string) => {
  return date.length > 10 ? date.substr(0, 10).replaceAll("-", ".") : date;
};

export const priceToString = (price: number) => {
  return typeof price !== "undefined" && price != null ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : price;
};
